import React from "react";
import { Quote } from "lucide-react";

/**
 * TestimonialsSection — testimonios curados desde NPS (dinámico).
 * Si no hay testimonios, devuelve null.
 */
export function TestimonialsSection({ testimonials }) {
  if (!testimonials || testimonials.length === 0) return null;

  const gridCols =
    testimonials.length === 1
      ? "max-w-2xl"
      : testimonials.length === 2
        ? "md:grid-cols-2"
        : "md:grid-cols-2 lg:grid-cols-3";

  return (
    <section
      className="border-b border-gray-200 bg-white"
      data-testid="landing-testimonials-section"
    >
      <div className="container-prose py-20">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">
            Voces de quienes ya lo usan
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 mb-3">
            Lo que dicen abogados y entidades sobre Procure.
          </h2>
        </div>
        <ul className={`grid gap-6 ${gridCols}`} data-testid="testimonials-grid">
          {testimonials.map((t) => (
            <li
              key={t.id}
              data-testid={`testimonial-public-${t.id}`}
              className="relative bg-brand-cream-soft border border-gray-200 rounded-sm p-7 flex flex-col hover:border-brand-burgundy transition-colors"
            >
              <Quote
                className="absolute top-4 right-5 h-7 w-7 text-brand-coral opacity-40"
                aria-hidden="true"
              />
              <blockquote className="font-serif text-base text-gray-800 leading-relaxed mb-5 flex-1">
                &ldquo;{t.display_quote || "—"}&rdquo;
              </blockquote>
              <div className="border-t border-gray-200 pt-4">
                <div className="font-medium text-sm text-gray-900">{t.display_name}</div>
                <div className="text-xs text-gray-600 mt-0.5">
                  {t.display_role}
                  {t.display_entity ? ` · ${t.display_entity}` : ""}
                </div>
                {typeof t.nps_score === "number" && (
                  <div className="text-[10px] uppercase tracking-widest text-emerald-700 mt-2">
                    NPS · {t.nps_score}/10
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
